import React from 'react'

export const PageTitle = ({ value }: { value: string }) => (
  <div className="fs-1 fw-300">{value}</div>
)
